import React from 'react';

interface ESStatusBarStartTextProps {
  label?: string;
  value?: string | number;
}

const ESStatusBarStartText: React.FC<ESStatusBarStartTextProps> = ({ label, value }) => {
  return (
    <div className="w-[70px] text-xs text-[#616061] font-normal font-dm-sans tracking-[0.24px]">
      {value && <span>{value}</span>}
      {label && <span className="ml-1">{label}</span>}
    </div>
  );
};

interface ESStatusBarEndTextProps {
  label?: string;
  value?: string | number;
}

const ESStatusBarEndText: React.FC<ESStatusBarEndTextProps> = ({ label, value }) => {
  return (
    <div className="w-[26px] text-xs text-[#616061] font-normal font-dm-sans tracking-[0.24px]">
      {label && <span>{label}</span>}
      {value != null && <span className="ml-1">{value}</span>}
    </div>
  );
};

interface ESStatusBarProgressProps {
  percentage: number;
  color?: string;
}

const ESStatusBarProgress: React.FC<ESStatusBarProgressProps> = ({
  percentage,
  color = '#00C65E'
}) => {
  const progressWidth = `${Math.min(Math.max(percentage, 0), 100)}%`;

  return (
    <div className="w-[121px] h-2 bg-content-quaternary rounded-full">
      <div
        className="h-2 rounded-full transition-all duration-300 ease-in-out"
        style={{
          width: progressWidth,
          backgroundColor: color
        }}
      />
    </div>
  );
};

interface ESStatusBarProps {
  startLabel?: string;
  startValue?: string | number;
  percentage: number;
  color?: string;
  endLabel?: string;
  endValue?: string | number;
  className?: string;
}

const ESStatusBar: React.FC<ESStatusBarProps> = ({
  startLabel,
  startValue,
  percentage,
  color = '#00C65E',
  endLabel,
  endValue,
  className = ''
}) => {
  return (
    <div className={`flex h-4 items-center gap-2 self-stretch ${className}`}>
      <ESStatusBarStartText label={startLabel} value={startValue} />
      <ESStatusBarProgress percentage={percentage} color={color} />
      <ESStatusBarEndText label={endLabel} value={endValue} />
    </div>
  );
};

export default ESStatusBar;
export { ESStatusBarStartText, ESStatusBarEndText, ESStatusBarProgress };
